import { useEffect, useRef, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const AdSlot = ({ placement, className = "" }) => {
  const [ads, setAds] = useState([]);
  const [i, setI] = useState(0);
  const seen = useRef(new Set());
  useEffect(() => { api.get("/ads", { params: { placement } }).then(({ data }) => setAds(data)).catch(() => {}); }, [placement]);
  useEffect(() => {
    if (ads.length < 2) return;
    const t = setInterval(() => setI((x) => (x + 1) % ads.length), 8000);
    return () => clearInterval(t);
  }, [ads.length]);
  const ad = ads[i];
  useEffect(() => {
    if (ad && !seen.current.has(ad.id)) { seen.current.add(ad.id); api.post(`/ads/${ad.id}/impression`).catch(() => {}); }
  }, [ad]);
  if (!ad) return null;
  return (
    <a href={ad.link_url} target="_blank" rel="noopener noreferrer sponsored" data-testid={`ad-slot-${placement}`}
      onClick={() => api.post(`/ads/${ad.id}/click`).catch(() => {})}
      className={`group relative flex items-stretch overflow-hidden rounded-2xl border border-amber-500/20 bg-[#121216] transition-colors duration-300 hover:border-amber-400/50 ${className}`}>
      <img src={`${BACKEND}${ad.image_url}`} alt={ad.title} className="h-24 w-32 shrink-0 object-cover sm:h-28 sm:w-48" />
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-1 px-4 py-3">
        <span data-testid={`ad-sponsored-label-${placement}`} className="text-[10px] font-semibold uppercase tracking-[0.25em] text-amber-400/80">Sponsored</span>
        <span data-testid={`ad-title-${placement}`} className="line-clamp-2 text-sm font-medium text-amber-50 sm:text-base">{ad.title}</span>
      </div>
      <ArrowUpRight className="mr-4 h-5 w-5 shrink-0 self-center text-amber-300 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </a>
  );
};
